import React from "react";

export default function RuleChips({ rules }) {
  if (!rules || !rules.length) return null;
  return (
    <div className="rule-chips">
      {rules.map((r, i) => {
        const name = typeof r === "string" ? r : r.name;
        const title = typeof r === "object" && r.text ? r.text : undefined;
        return (
          <span className="rule-chip" key={i} title={title}>
            {name}
          </span>
        );
      })}
    </div>
  );
}
